var Industry = "Ngành";
var Aerospace = "Hàng không vũ trụ";
var Agriculture = "Nông nghiệp";
var Automotive = "Ô tô";
var Education = "Giáo dục";
var Gaming = "Trò chơi";
var Government = "Chính phủ";
var Healthcare = "Chăm sóc sức khỏe";
var Hospitality = "Nhà hàng - Khách sạn";
var Manufacturing = "Sản xuất";
var Mining = "Khai thác mỏ";
var Other = "Khác";
var Retail = "Kinh doanh nhỏ lẻ";
var Telecommunications = "Viễn thông";
var Travel = "Du lịch";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Máy tính và điện tử",
	"Consumer goods": "Hàng tiêu dùng",
	Education: Education,
	"Financial services": "Dịch vụ tài chính",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Khoa học đời sống",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Tiếp thị & quảng cáo",
	"Media & entertainment": "Truyền thông & giải trí",
	Mining: Mining,
	"Non-profit organization": "Tổ chức phi lợi nhuận",
	"Oil & gas": "Dầu khí",
	Other: Other,
	"Power & utilities": "Điện và tiện ích",
	"Professional services": "Dịch vụ chuyên nghiệp",
	"Real estate & construction": "Bất động sản & xây dựng",
	Retail: Retail,
	"Software & internet": "Phần mềm và Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Vận tải và kho vận",
	Travel: Travel,
	"Wholesale & distribution": "Bán buôn & phân phối"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
